import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon awesome-bookmark",
  "use": "icon-Icon awesome-bookmark-usage",
  "viewBox": "0 0 10.193 13.591",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.193 13.591\" id=\"icon-Icon awesome-bookmark\">\r\n  <path id=\"icon-Icon awesome-bookmark_Icon_awesome-bookmark-2\" data-name=\"Icon awesome-bookmark\" d=\"M0,13.591V1.274A1.274,1.274,0,0,1,1.274,0H8.919a1.274,1.274,0,0,1,1.274,1.274V13.591L5.1,10.618Z\" fill=\"#ef7681\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol